import { CreateElement, VNode } from 'vue';
import { Component } from 'vue-property-decorator';
import { gdpr } from '../app.config';
import { Acceptance } from '../helpers/gdpr';
import BaseComponent from './Base';

@Component
export default class CookieConsent extends BaseComponent {

    protected isShown: boolean = false;

    public resolve(confirm: Acceptance = Acceptance.YES): void {
        gdpr.accept(confirm);
        this.$el.remove();
        this.$destroy();
    }

    public mounted(): void {
        if (!this.isShown) {
            return;
        }
        Array.from(document.querySelectorAll('a[href]')).forEach((link) => {
            if (link.closest('.c-cookie-consent')) {
                return;
            }
            link.addEventListener('click', () => this.resolve());
        });
    }

    public render(createElement: CreateElement): VNode {
        if (gdpr.alreadyAccepted) {
            return createElement();
        }

        this.isShown = true;

        return createElement('div', {
            staticClass: 'c-cookie-consent',
            on: {
                click: (e: MouseEvent) => {
                    if (!(e.target instanceof HTMLElement)) {
                        return;
                    }
                    const [tag, href] = [e.target.tagName.toLowerCase(), e.target.getAttribute('href')];
                    if (tag !== 'a' || href) {
                        return;
                    }
                    this.resolve(Acceptance.NO);
                },
            },
        }, [
            this.$slots.default,
            createElement('button', {
                attrs: {
                    type: 'button',
                    class: 'c-button c-button--uppercase',
                },
                on: {
                    click: () => this.resolve(),
                },
            }, 'OK'),
        ]);
    }
}
